export default {
    data() {
        return {
            valid: {
                country: false,
                mobile: false,
                password: false,
                password_confirmation: false
            },
            success: {
                country: false,
                mobile: false,
                password: false,
                password_confirmation: false
            },
            error: {
                country: "",
                mobile: "",
                password: "",
                password_confirmation: "",
            },
            errorMessages: {
                
                mobileInvalid: {
                    en: "Please enter a valid phone number.",
                    el: "Παρακαλώ εισάγετε έναν έγκυρο αριθμό τηλεφώνου.",
                    it: "Si prega di inserire un numero di telefono valido."
                },
                mobileLength: {
                    en: "Mobile phone must be between 7 and 12 characters long.",
                    el: "Το κινητό τηλέφωνο πρέπει να έχει μήκος μεταξύ 7 και 12 χαρακτήρων.",
                    it: "Il cellulare deve avere una lunghezza compresa tra 7 e 12 caratteri."
                },
                passwordConfirmation: {
                    en: "The passwords do not match.",
                    el: "Οι κωδικοί πρόσβασης δεν ταιριάζουν.",
                    it: "Le password non corrispondono."
                },
                countryRequired: {
                    el: "Απαιτείται κωδικός χώρας",
                    en: "Country code is required",
                    it: "Il codice paese è richiesto"
                },  
                passwordRequired: {
                    el: "Απαιτείται κωδικός πρόσβασης",
                    en: "Password is required",
                    it: "La password è necessaria"
                },
                passwordLength: {
                    el: "Ο κωδικός πρόσβασης πρέπει να αποτελείται από τουλάχιστον 5 χαρακτήρες",
                    en: "Password must be at least 5 characters long",
                    it: "La password deve essere di almeno 5 caratteri"
                }
            }
        };
    },

    methods: {
        
        validateCountry() {
            this.valid.country = !!this.countryId;
            this.success.country = !!this.countryId;
            if (!this.countryId) {
                this.error.country = this.errorMessages.countryRequired[
                    this.lang
                ];
            } else {
                this.error.country = "";
            }
        },

        validateMobile() {
                this.valid.mobile = false;
                this.success.mobile = false;
            if (!this.mobile) {
                this.error.mobile = this.errorMessages.mobileInvalid[
                    this.lang
                ];
            } else if (this.mobile.length < 7 || this.mobile.length > 12 ) {
                this.error.mobile = this.errorMessages.mobileLength[this.lang];
            } else {
                this.error.mobile = "";
                this.valid.mobile = true;
                this.success.mobile = true;
                this.validateCountry();
            }
        },
        
        validatePassword() {
            if (!this.password) {
                this.error.password = this.errorMessages.passwordRequired[
                    this.lang
                ];
            } else if (this.password.length < 5) {
                this.error.password = this.errorMessages.passwordLength[
                    this.lang
                ];
            } else {
                this.error.password = "";
            }
        },

        validatePasswordConfirmation() {
            if (this.passwordConfirmation && this.passwordConfirmation !== this.password) {
                this.error.password_confirmation = this.errorMessages.passwordConfirmation[
                    this.lang
                ];
            } else {
                this.error.password_confirmation = "";
            }
        },
    },

    watch: {
        ["mobile"](val) {
            this.valid.mobile = val?.length >= 7 && val?.length <= 12;
            this.success.mobile = val?.length >= 7 && val?.length <= 12;
        },

        ["countryId"]: {
            handler(val) {
                this.valid.country = !!val;
                this.success.country = !!val;
            }
        },
        ["password"]: {
            handler(val) {
                this.success.password = val?.length >= 5;
                this.valid.password = val?.length >= 5;
            }
        },
        ["passwordConfirmation"](val) {
            if (val && val === this.password) {
                this.valid.password_confirmation = this.valid.password;
                this.success.password_confirmation = this.success.password;
            } else {
                this.valid.password_confirmation = false;
                this.success.password_confirmation = false;
            }
        },
    }
};
